import { render } from "./subj_assign.vue?vue&type=template&id=87020ce0"
import script from "./subj_assign.vue?vue&type=script&lang=js"
export * from "./subj_assign.vue?vue&type=script&lang=js"

import "./subj_assign.vue?vue&type=style&index=0&id=87020ce0&lang=css"

import exportComponent from "D:\\_FEproject\\aplikovanainformatika.sk\\zoneai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__